import { useState } from "react";
import { Header } from "../components/Header";
import { MSHeroSection } from "../components/MSHeroSection";
import { BenefitsSection } from "../components/BenefitsSection";
import { HowItWorksSection } from "../components/HowItWorksSection";
import { WebinarSection } from "../components/WebinarSection";
import { FeaturesSection } from "../components/FeaturesSection";
import { PricingSection } from "../components/PricingSection";
import { FAQSection } from "../components/FAQSection";
import { ContactSection } from "../components/ContactSection";
import { BackOfficeSection } from "../components/BackOfficeSection";
import { Footer } from "../components/Footer";
import { InfoRequestModal } from "../components/InfoRequestModal";

export default function LandingPage() {
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const handleOrderClick = () => {
    const el = document.querySelector('#pricing');
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const handleInfoClick = () => setInfoModalOpen(true);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <MSHeroSection onOrderClick={handleOrderClick} onInfoClick={handleInfoClick} />
      <BenefitsSection />
      <HowItWorksSection onOrderClick={handleOrderClick} onInfoClick={handleInfoClick} />
      <WebinarSection onOrderClick={handleOrderClick} schoolType="ms" />
      <FeaturesSection />
      <PricingSection onOrderClick={handleOrderClick} onInfoClick={handleInfoClick} />
      <FAQSection />
      <ContactSection />
      <BackOfficeSection />
      <InfoRequestModal open={infoModalOpen} onOpenChange={setInfoModalOpen} />
    </div>
  );
}
